import { render } from "./Controls.vue?vue&type=template&id=5c13fee2&scoped=true"
import script from "./Controls.vue?vue&type=script&lang=js"
export * from "./Controls.vue?vue&type=script&lang=js"

import "./Controls.vue?vue&type=style&index=0&id=5c13fee2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c13fee2"]])

export default __exports__